import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useWalletStore } from '@/stores/wallet';
import BrandMark from '@/components/BrandMark';
import MultisigPicker from '@/components/MultisigPicker';
import WalletPicker from '@/components/WalletPicker';

function shortAddr(addr: string) {
  return addr.slice(0, 4) + '…' + addr.slice(-4);
}

export default function AppHeader() {
  const pubkey = useWalletStore((s) => s.pubkey);
  const walletName = useWalletStore((s) => s.walletName);
  const walletIcon = useWalletStore((s) => s.walletIcon);
  const connecting = useWalletStore((s) => s.connecting);
  const disconnect = useWalletStore((s) => s.disconnect);
  const [pickerOpen, setPickerOpen] = useState(false);

  const isConnected = pubkey !== null;

  return (
    <header className="flex items-center justify-between gap-4 border-b border-ink-700 bg-ink-950/80 px-4 lg:px-6 py-3 backdrop-blur sticky top-0 z-20">
      <div className="flex items-center gap-3 lg:hidden">
        <Link to="/" className="flex items-center">
          <BrandMark variant="sign" size="md" showSubBadge={false} />
        </Link>
      </div>

      <div className="flex-1 flex items-center gap-2">
        {isConnected && <MultisigPicker />}
      </div>

      <div className="flex items-center gap-2">
        {!isConnected ? (
          <button
            type="button"
            onClick={() => setPickerOpen(true)}
            disabled={connecting}
            className="rounded-md bg-avo-500 px-4 py-2 text-sm font-semibold text-black hover:bg-avo-600 transition-colors disabled:opacity-50"
          >
            {connecting ? 'Connecting…' : 'Connect Wallet'}
          </button>
        ) : (
          <button
            type="button"
            onClick={() => void disconnect()}
            className="rounded-md border border-ink-700 bg-ink-900 px-3 py-1.5 text-sm text-ink-100 hover:border-ink-600 hover:bg-ink-800 transition-colors flex items-center gap-2"
          >
            {walletIcon && (
              <img
                src={walletIcon}
                alt={walletName ?? ''}
                className="w-4 h-4 rounded-sm"
              />
            )}
            <span className="font-mono text-xs">
              {pubkey ? shortAddr(pubkey) : ''}
            </span>
          </button>
        )}
      </div>

      {pickerOpen && <WalletPicker onClose={() => setPickerOpen(false)} />}
    </header>
  );
}
